<ng-container *transloco="let t; read: 'user'">
  <div class="rounded-lg fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">{{ t('manageEnrollment.classEnrollments.editDialog.title') }}</h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>
    @if (studentEnrollmentInfo) {
      <div mat-dialog-content>
        <form class="grid grid-cols-2 gap-2 gap-x-10 p-3" [formGroup]="editForm">
          <div class="col-span-1 mt-2">
            <label class="font-bold mb-1">{{ t('manageEnrollment.viewChild.labels.ratingPeriod') }}</label>
            <p>
              <!-- Server-supplied rating period name: localized by the API, not by Transloco. -->
              {{ studentEnrollmentInfo.ratingPeriodName }}
            </p>
          </div>
          <div class="col-span-1 mt-2">
            <label class="font-bold mb-1">{{ t('manageEnrollment.viewChild.labels.classroom') }}</label>
            <p>
              <!-- Server-supplied classroom name. -->
              {{ studentEnrollmentInfo.name }}
            </p>
          </div>
          <div class="col-span-1">
            <drdp-date-picker
              [label]="t('manageEnrollment.viewChild.labels.classroomStartDate')"
              labelClasses="pb-1 whitespace-nowrap"
              [initialDate]="classEnrollmentDate?.value"
              [isRequired]="true"
              [minDate]="studentEnrollmentInfo.enrollmentStartDate"
              [maxDate]="studentEnrollmentInfo.ratingPeriodMaxDate"
              (emitDate)="handleDate($event)">
            </drdp-date-picker>
          </div>
          <div class="col-span-1 mt-2">
            <label class="font-bold mb-1">{{ t('manageEnrollment.classEnrollments.editDialog.classroomWithdrawalDate') }}</label>
            <p>
              {{ studentEnrollmentInfo.classExitDate | localizedDate:'MM/dd/yyyy' }}
            </p>
          </div>
          <div class="col-span-1 mt-2">
            <label class="font-bold mb-1">{{ t('manageEnrollment.classEnrollments.table.site') }}</label>
            <p>
              <!-- Server-supplied site name. -->
              {{ studentEnrollmentInfo.siteName }}
            </p>
          </div>
          @if (studentEnrollmentInfo.isDualEnrollment || this.studentEnrollmentInfo.is2025Enrollment) {
            <div class="col-span-1 mt-2">
              <drdp-select-age-grade
                #ageGroupInstrumentSelect
                [initialageGradeId]="ageGradeId.value"
                (ageGrade)="handleAgeGrade($event)"
                [stateId]="stateId"
                [multiSelect]="false"
                [required]="true"
                [label]="t('manageEnrollment.classEnrollments.editDialog.childAgeGradeInstrument')"
                [isPilot]="studentEnrollmentInfo.is2025Enrollment"
                [schoolYearId]="schoolYearId"
                >
              </drdp-select-age-grade>
            </div>
          }
        </form>
      </div>
    }
    <div mat-dialog-actions class="flex justify-end">
      <drdp-btn class="mx-2" color="cancel" mat-button mat-dialog-close>{{ t('manageEnrollment.viewChild.actions.cancel') }}</drdp-btn>
      <drdp-btn
        mat-button
        [disabled]="editForm.invalid || editForm.pristine"
      (click)="onSubmit()">{{ t('manageEnrollment.classEnrollments.editDialog.save') }}</drdp-btn>
    </div>
  </div>
</ng-container>
